webpackJsonp([182681245775973],{

/***/ 124:
/***/ (function(module, exports) {

	'use strict';
	
	
	function is_nil_undef(x) {
	  if (x === null) {
	    return true;
	  } else {
	    return x === undefined;
	  }
	}
	
	function null_undefined_to_opt(x) {
	  if (x === null || x === undefined) {
	    return /* None */0;
	  } else {
	    return /* Some */[x];
	  }
	}
	
	function undefined_to_opt(x) {
	  if (x === undefined) {
	    return /* None */0;
	  } else {
	    return /* Some */[x];
	  }
	}
	
	function null_to_opt(x) {
	  if (x === null) {
	    return /* None */0;
	  } else {
	    return /* Some */[x];
	  }
	}
	
	function option_get(x) {
	  if (x) {
	    return x[0];
	  } else {
	    return undefined;
	  }
	}
	
	function option_get_unwrap(x) {
	  if (x) {
	    return x[0][1];
	  } else {
	    return undefined;
	  }
	}
	
	exports.is_nil_undef = is_nil_undef;
	exports.null_undefined_to_opt = null_undefined_to_opt;
	exports.undefined_to_opt = undefined_to_opt;
	exports.null_to_opt = null_to_opt;
	exports.option_get = option_get;
	exports.option_get_unwrap = option_get_unwrap;
	/* No side effect */


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _glamor = __webpack_require__(92);
	
	/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */
	
	/**
	 * 1. Change the default font family in all browsers (opinionated).
	 * 2. Correct the line height in all browsers.
	 * 3. Prevent adjustments of font size after orientation changes in
	 *    IE on Windows Phone and in iOS.
	 */
	
	/* Document
	   ========================================================================== */
	
	_glamor.css.insert('html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}');
	
	/* Sections
	   ========================================================================== */
	
	/**
	 * Remove the margin in all browsers (opinionated).
	 */
	
	_glamor.css.insert('body {\n  margin: 0;\n}');
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('article,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}');
	
	/**
	 * Correct the font size and margin on `h1` elements within `section` and
	 * `article` contexts in Chrome, Firefox, and Safari.
	 */
	
	_glamor.css.insert('h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}');
	
	/* Grouping content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in IE.
	 */
	
	_glamor.css.insert('figcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}');
	
	/**
	 * Add the correct margin in IE 8.
	 */
	
	_glamor.css.insert('figure {\n  margin: 1em 40px;\n}');
	
	/**
	 * 1. Add the correct box sizing in Firefox.
	 * 2. Show the overflow in Edge and IE.
	 */
	
	_glamor.css.insert('hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	_glamor.css.insert('pre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/* Text-level semantics
	   ========================================================================== */
	
	/**
	 * 1. Remove the gray background on active links in IE 10.
	 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
	 */
	
	_glamor.css.insert('a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}');
	
	/**
	 * Remove the outline on focused links when they are also active or hovered
	 * in all browsers (opinionated).
	 */
	
	_glamor.css.insert('a:active,\na:hover {\n  outline-width: 0;\n}');
	
	/**
	 * 1. Remove the bottom border in Firefox 39-.
	 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	 */
	
	_glamor.css.insert('abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}');
	
	/**
	 * Prevent the duplicate application of `bolder` by the next rule in Safari 6.
	 */
	
	_glamor.css.insert('b,\nstrong {\n  font-weight: inherit;\n}');
	
	/**
	 * Add the correct font weight in Chrome, Edge, and Safari.
	 */
	
	_glamor.css.insert('b,\nstrong {\n  font-weight: bolder;\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	_glamor.css.insert('code,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/**
	 * Add the correct font style in Android 4.3-.
	 */
	
	_glamor.css.insert('dfn {\n  font-style: italic;\n}');
	
	/**
	 * Add the correct background and color in IE 9-.
	 */
	
	_glamor.css.insert('mark {\n  background-color: #ff0;\n  color: #000;\n}');
	
	/**
	 * Add the correct font size in all browsers.
	 */
	
	_glamor.css.insert('small {\n  font-size: 80%;\n}');
	
	/**
	 * Prevent `sub` and `sup` elements from affecting the line height in
	 * all browsers.
	 */
	
	_glamor.css.insert('sub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}');
	
	_glamor.css.insert('sub {\n  bottom: -0.25em;\n}');
	
	_glamor.css.insert('sup {\n  top: -0.5em;\n}');
	
	/* Embedded content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('audio,\nvideo {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in iOS 4-7.
	 */
	
	_glamor.css.insert('audio:not([controls]) {\n  display: none;\n  height: 0;\n}');
	
	/**
	 * Remove the border on images inside links in IE 10-.
	 */
	
	_glamor.css.insert('img {\n  border-style: none;\n}');
	
	/**
	 * Hide the overflow in IE.
	 */
	
	_glamor.css.insert('svg:not(:root) {\n  overflow: hidden;\n}');
	
	/* Forms
	   ========================================================================== */
	
	/**
	 * 1. Change the font styles in all browsers (opinionated).
	 * 2. Remove the margin in Firefox and Safari.
	 */
	
	_glamor.css.insert('button,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}');
	
	/**
	 * Show the overflow in IE.
	 * 1. Show the overflow in Edge.
	 */
	
	_glamor.css.insert('button,\ninput { /* 1 */\n  overflow: visible;\n}');
	
	/**
	 * Remove the inheritance of text transform in Edge, Firefox, and IE.
	 * 1. Remove the inheritance of text transform in Firefox.
	 */
	
	_glamor.css.insert('button,\nselect { /* 1 */\n  text-transform: none;\n}');
	
	/**
	 * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`
	 *    controls in Android 4.
	 * 2. Correct the inability to style clickable types in iOS and Safari.
	 */
	
	_glamor.css.insert('button,\nhtml [type="button"], /* 1 */\n[type="reset"],\n[type="submit"] {\n  -webkit-appearance: button; /* 2 */\n}');
	
	/**
	 * Remove the inner border and padding in Firefox.
	 */
	
	_glamor.css.insert('button::-moz-focus-inner,\n[type="button"]::-moz-focus-inner,\n[type="reset"]::-moz-focus-inner,\n[type="submit"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}');
	
	/**
	 * Restore the focus styles unset by the previous rule.
	 */
	
	_glamor.css.insert('button:-moz-focusring,\n[type="button"]:-moz-focusring,\n[type="reset"]:-moz-focusring,\n[type="submit"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}');
	
	/**
	 * Change the border, margin, and padding in all browsers (opinionated).
	 */
	
	_glamor.css.insert('fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}');
	
	/**
	 * 1. Correct the text wrapping in Edge and IE.
	 * 2. Correct the color inheritance from `fieldset` elements in IE.
	 * 3. Remove the padding so developers are not caught out when they zero out
	 *    `fieldset` elements in all browsers.
	 */
	
	_glamor.css.insert('legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}');
	
	/**
	 * 1. Add the correct display in IE 9-.
	 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
	 */
	
	_glamor.css.insert('progress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}');
	
	/**
	 * Remove the default vertical scrollbar in IE.
	 */
	
	_glamor.css.insert('textarea {\n  overflow: auto;\n}');
	
	/**
	 * 1. Add the correct box sizing in IE 10-.
	 * 2. Remove the padding in IE 10-.
	 */
	
	_glamor.css.insert('[type="checkbox"],\n[type="radio"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}');
	
	/**
	 * Correct the cursor style of increment and decrement buttons in Chrome.
	 */
	
	_glamor.css.insert('[type="number"]::-webkit-inner-spin-button,\n[type="number"]::-webkit-outer-spin-button {\n  height: auto;\n}');
	
	/**
	 * 1. Correct the odd appearance in Chrome and Safari.
	 * 2. Correct the outline style in Safari.
	 */
	
	_glamor.css.insert('[type="search"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}');
	
	/**
	 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
	 */
	
	_glamor.css.insert('[type="search"]::-webkit-search-cancel-button,\n[type="search"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}');
	
	/**
	 * 1. Correct the inability to style clickable types in iOS and Safari.
	 * 2. Change font properties to `inherit` in Safari.
	 */
	
	_glamor.css.insert('::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}');
	
	/* Interactive
	   ========================================================================== */
	
	/*
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in Edge, IE, and Firefox.
	 */
	
	_glamor.css.insert('details, /* 1 */\nmenu {\n  display: block;\n}');
	
	/*
	 * Add the correct display in all browsers.
	 */
	
	_glamor.css.insert('summary {\n  display: list-item;\n}');
	
	/* Scripting
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('canvas {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in IE.
	 */
	
	_glamor.css.insert('template {\n  display: none;\n}');
	
	/* Hidden
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 10-.
	 */
	
	_glamor.css.insert('[hidden] {\n  display: none;\n}');

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var TypedGlamor = __webpack_require__(4);
	var GlobalStyles = __webpack_require__(85);
	
	var widthContainer = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.label("width-container"),
	/* :: */[TypedGlamor.margin2(TypedGlamor.zero, TypedGlamor.auto),
	/* :: */[TypedGlamor.maxWidth(TypedGlamor.px(960)),
	/* :: */[TypedGlamor.minWidth(TypedGlamor.px(359)),
	/* :: */[TypedGlamor.width(TypedGlamor.pct(100)),
	/* [] */0]]]]]);
	
	var html = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.select("& h1", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(2.25)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h2", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(1.62671)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h3", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(1.38316)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h1, & h2, & h3, & h4, & h5", /* :: */[TypedGlamor.select("& > a.anchor", /* :: */[TypedGlamor.marginLeft(TypedGlamor.px(-20)),
	/* :: */[TypedGlamor.paddingRight(TypedGlamor.px(4)),
	/* :: */[TypedGlamor.select("& > svg", /* :: */[TypedGlamor.visibility(TypedGlamor.hidden),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.select("& > a.anchor > svg", /* :: */[TypedGlamor.visibility(TypedGlamor.visible),
	/* [] */0]),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& p", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.select("& *:last-child", /* :: */[TypedGlamor.marginBottom(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& b, & strong", /* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& i, & em", /* :: */[TypedGlamor.fontStyle(TypedGlamor.italic),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& ol, & ul", /* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.marginLeft(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.unsafe("listStylePosition", "outside"),
	/* :: */[TypedGlamor.unsafe("listStyleImage", "none"),
	/* [] */0]]]]]),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* :: */[TypedGlamor.select("& > ol, & > ul", /* :: */[TypedGlamor.marginLeft(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* :: */[TypedGlamor.marginTop(TypedGlamor.rem(1.45 / 2)),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("& *:last-child", /* :: */[TypedGlamor.marginBottom(TypedGlamor.zero),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > p", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* [] */0]),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& ol", /* :: */[TypedGlamor.unsafe("listStyleType", "decimal"),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.paddingLeft(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& ul", /* :: */[TypedGlamor.unsafe("listStyleType", "disc"),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.paddingLeft(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& code", /* :: */[TypedGlamor.background(TypedGlamor.hsla(TypedGlamor.num(0), 0, 0, 0.04)),
	/* :: */[TypedGlamor.fontFamilies( /* :: */["'SFMono-Regular'",
	/* :: */["Consolas",
	/* :: */["'Roboto Mono'",
	/* :: */["'Droid Sans Mono'",
	/* :: */["'Liberation Mono'",
	/* :: */["Menlo",
	/* :: */["Courier",
	/* :: */["monospace",
	/* [] */0]]]]]]]]),
	/* :: */[TypedGlamor.fontSize(TypedGlamor.rem(0.85)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(0.2), TypedGlamor.zero),
	/* [] */0]]]]]),
	/* :: */[TypedGlamor.select("& pre", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.fontSize(TypedGlamor.rem(0.85)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.rem(1.42)),
	/* :: */[TypedGlamor.background(TypedGlamor.hsla(TypedGlamor.num(0), 0, 0, 0.04)),
	/* :: */[TypedGlamor.overflow(TypedGlamor.auto),
	/* :: */[TypedGlamor.unsafe("wordWrap", "normal"),
	/* :: */[TypedGlamor.padding(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.select("& code", /* :: */[TypedGlamor.background(TypedGlamor.none),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.42)),
	/* [] */0]]),
	/* [] */0]]]]]]]]),
	/* :: */[TypedGlamor.select("& a", /* :: */[TypedGlamor.color(Theme.Color[/* link */5]),
	/* :: */[TypedGlamor.textDecoration(TypedGlamor.none),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.textDecoration(TypedGlamor.underline),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("& img", /* :: */[TypedGlamor.maxWidth(TypedGlamor.pct(100)),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& .redex-codeblock.m-tabbed", /* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.position(TypedGlamor.relative),
	/* :: */[TypedGlamor.select("& > ul", /* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.position(TypedGlamor.absolute),
	/* :: */[TypedGlamor.flexDirection(TypedGlamor.column),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.opacity(0),
	/* :: */[TypedGlamor.transitions( /* :: */[
	/* tuple */[TypedGlamor.AnimatableProperty[/* opacity */76], TypedGlamor.ms(400), TypedGlamor.easeInOut, TypedGlamor.ms(200)],
	/* [] */0]),
	/* :: */[TypedGlamor.transforms( /* :: */[TypedGlamor.translateX(TypedGlamor.pct(-100)),
	/* [] */0]),
	/* :: */[TypedGlamor.height(TypedGlamor.pct(100)),
	/* :: */[TypedGlamor.select("& > li", /* :: */[TypedGlamor.cursor(TypedGlamor.pointer),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.display(TypedGlamor.inlineBlock),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(0.35), TypedGlamor.em(0.75)),
	/* :: */[TypedGlamor.color(TypedGlamor.white),
	/* :: */[TypedGlamor.textTransform(TypedGlamor.lowercase),
	/* :: */[TypedGlamor.fontVariant(TypedGlamor.smallCaps),
	/* :: */[TypedGlamor.select("&:not(.s-selected)", /* :: */[TypedGlamor.opacity(0.5),
	/* :: */[TypedGlamor.boxShadows( /* :: */[TypedGlamor.shadow(TypedGlamor.zero, TypedGlamor.px(-4), /* Some */[TypedGlamor.px(-2)], /* Some */[TypedGlamor.px(-2)], /* Some */[true], TypedGlamor.rgba(0, 0, 0, 0.1)),
	/* [] */0]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.opacity(1),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("&.reason", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* reason */8]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("&.ml", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* ocaml */9]),
	/* [] */0]),
	/* [] */0]]]]]]]]]]),
	/* [] */0]]]]]]]]]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.select("& > ul", /* :: */[TypedGlamor.opacity(1),
	/* [] */0]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > .codeblock", /* :: */[TypedGlamor.display(TypedGlamor.none),
	/* :: */[TypedGlamor.flex_(TypedGlamor.$$int(1)),
	/* :: */[TypedGlamor.maxWidth(TypedGlamor.pct(100)),
	/* :: */[TypedGlamor.select("&.s-selected", /* :: */[TypedGlamor.display(TypedGlamor.block),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > pre", /* :: */[TypedGlamor.marginTop(TypedGlamor.zero),
	/* :: */[TypedGlamor.select("&.lang-reason", /* :: */[TypedGlamor.borderLeft3(TypedGlamor.px(2), TypedGlamor.solid, Theme.Color[/* reason */8]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("&.lang-ml", /* :: */[TypedGlamor.borderLeft3(TypedGlamor.px(2), TypedGlamor.solid, Theme.Color[/* ocaml */9]),
	/* [] */0]),
	/* [] */0]]]),
	/* [] */0]]]]]),
	/* [] */0]]]]]),
	/* [] */0]]]]]]]]]]]]]]]]);
	
	var _reset = GlobalStyles._reset;
	
	var _global = GlobalStyles._global;
	
	exports._reset = _reset;
	exports._global = _global;
	exports.widthContainer = widthContainer;
	exports.html = html;
	/* widthContainer Not a pure module */

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var TypedGlamor = __webpack_require__(4);
	
	__webpack_require__(91);
	
	TypedGlamor.$$global("*", /* :: */[TypedGlamor.unsafe("boxSizing", "border-box"),
	/* [] */0]);
	
	TypedGlamor.$$global("*:focus", /* :: */[TypedGlamor.outlineStyle(TypedGlamor.none),
	/* [] */0]);
	
	TypedGlamor.$$global("body", /* :: */[TypedGlamor.lineHeight(TypedGlamor.inherit_),
	/* :: */[TypedGlamor.color(Theme.Color[/* text */4]),
	/* [] */0]]);
	
	TypedGlamor.$$global("h1, h2, h3", /* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.normal),
	/* [] */0]]);
	
	TypedGlamor.$$global("a", /* :: */[TypedGlamor.color(TypedGlamor.inherit_),
	/* [] */0]);
	
	TypedGlamor.$$global("button, input, select", /* :: */[TypedGlamor.background(TypedGlamor.none),
	/* :: */[TypedGlamor.border(TypedGlamor.none),
	/* :: */[TypedGlamor.font(TypedGlamor.inherit_),
	/* [] */0]]]);
	
	TypedGlamor.$$global("button::-moz-focus-inner", /* :: */[TypedGlamor.outline(TypedGlamor.none),
	/* [] */0]);
	
	var _reset = TypedGlamor.$$global("ol, ul", /* :: */[TypedGlamor.unsafe("listStyle", "none"),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.padding(TypedGlamor.zero),
	/* [] */0]]]);
	
	TypedGlamor.$$global("html", /* :: */[TypedGlamor.fontSize(TypedGlamor.px(15)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.25)),
	/* :: */[TypedGlamor.fontFamilies( /* :: */["-apple-system",
	/* :: */["BlinkMacSystemFont",
	/* :: */["Segoe UI",
	/* :: */["Roboto",
	/* :: */["Oxygen",
	/* :: */["Ubuntu",
	/* :: */["Cantarell",
	/* :: */["Fira Sans",
	/* :: */["Droid Sans",
	/* :: */["Helvetica Neue",
	/* :: */["sans-serif",
	/* [] */0]]]]]]]]]]]),
	/* :: */[TypedGlamor.unsafe("boxSizing", "border-box"),
	/* :: */[TypedGlamor.unsafe("overflowY", "scroll"),
	/* [] */0]]]]]);
	
	var _global = TypedGlamor.$$global("html, body, #___gatsby", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* background */2]),
	/* :: */[TypedGlamor.minHeight(TypedGlamor.pct(100)),
	/* [] */0]]);
	
	exports._reset = _reset;
	exports._global = _global;
	/*  Not a pure module */

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var TypedGlamor = __webpack_require__(4);
	var CommonStyles = __webpack_require__(56);
	
	var root = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.marginBottom(TypedGlamor.em(1.45)),
	/* [] */0]);
	
	var header = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.label("header"),
	/* :: */[TypedGlamor.backgroundColor(Theme.Inverted[/* Color */0][/* background */0]),
	/* :: */[TypedGlamor.color(Theme.Inverted[/* Color */0][/* text */1]),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(2), TypedGlamor.em(4)),
	/* :: */[TypedGlamor.select("@media (max-width: 900px)", /* :: */[TypedGlamor.padding2(TypedGlamor.em(1), TypedGlamor.em(2)),
	/* [] */0]),
	/* [] */0]]]]]);
	
	var props = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.justifyContent(TypedGlamor.flexEnd),
	/* :: */[TypedGlamor.alignItems(TypedGlamor.baseline),
	/* :: */[TypedGlamor.select("& > *", /* :: */[TypedGlamor.marginLeft(TypedGlamor.em(1)),
	/* [] */0]),
	/* [] */0]]]]);
	
	var title = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.padding3(TypedGlamor.em(1), TypedGlamor.zero, TypedGlamor.zero),
	/* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.alignItems(TypedGlamor.baseline),
	/* [] */0]]]);
	
	var owner = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.display(TypedGlamor.block),
	/* :: */[TypedGlamor.opacity(0.75),
	/* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.fontVariant(TypedGlamor.smallCaps),
	/* [] */0]]]]);
	
	var name = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(1.5)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.textDecoration(TypedGlamor.none),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.45)),
	/* :: */[TypedGlamor.select("&:hover", /* :: */[TypedGlamor.textDecoration(TypedGlamor.underline),
	/* [] */0]),
	/* [] */0]]]]]);
	
	var descLine = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.marginBottom(TypedGlamor.em(0.5)),
	/* [] */0]);
	
	var description = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.unsafe("textOverflow", "ellipsis"),
	/* :: */[TypedGlamor.overflow(TypedGlamor.hidden),
	/* :: */[TypedGlamor.opacity(0.75),
	/* [] */0]]]);
	
	var tags = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.select("& span", /* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.backgroundColor(Theme.Inverted[/* Color */0][/* block */2]),
	/* :: */[TypedGlamor.padding2(TypedGlamor.zero, TypedGlamor.ex(1)),
	/* :: */[TypedGlamor.opacity(1),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.backgroundColor(Theme.Inverted[/* Color */0][/* highlightedBlock */3]),
	/* :: */[TypedGlamor.cursor(TypedGlamor.pointer),
	/* [] */0]]),
	/* [] */0]]]]]),
	/* [] */0]);
	
	var tagsIcon = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.opacity(0.25),
	/* [] */0]);
	
	var right = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.textAlign(TypedGlamor.right),
	/* [] */0]);
	
	var updated = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.whiteSpace(TypedGlamor.nowrap),
	/* [] */0]]);
	
	var license = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.whiteSpace(TypedGlamor.nowrap),
	/* :: */[TypedGlamor.border3(TypedGlamor.px(1), TypedGlamor.solid, Theme.Inverted[/* Color */0][/* text */1]),
	/* :: */[TypedGlamor.padding2(TypedGlamor.zero, TypedGlamor.ex(1)),
	/* [] */0]]]]);
	
	var nolicense = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.whiteSpace(TypedGlamor.nowrap),
	/* :: */[TypedGlamor.border3(TypedGlamor.px(1), TypedGlamor.solid, TypedGlamor.hex("0008")),
	/* :: */[TypedGlamor.color(TypedGlamor.hex("0008")),
	/* :: */[TypedGlamor.padding2(TypedGlamor.zero, TypedGlamor.ex(1)),
	/* [] */0]]]]]);
	
	var stars = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.fontSize(TypedGlamor.em(0.85)),
	/* :: */[TypedGlamor.whiteSpace(TypedGlamor.nowrap),
	/* [] */0]]);
	
	var starIcon = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.marginLeft(TypedGlamor.em(0.25)),
	/* :: */[TypedGlamor.transforms( /* :: */[TypedGlamor.translateY(TypedGlamor.px(-1)),
	/* [] */0]),
	/* :: */[TypedGlamor.opacity(0.5),
	/* [] */0]]]);
	
	var links = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.label("links"),
	/* :: */[TypedGlamor.marginTop(TypedGlamor.em(3)),
	/* :: */[TypedGlamor.select("& > a", /* :: */[TypedGlamor.display(TypedGlamor.inlineBlock),
	/* :: */[TypedGlamor.textDecoration(TypedGlamor.none),
	/* :: */[TypedGlamor.marginRight(TypedGlamor.em(2)),
	/* :: */[TypedGlamor.fontVariant(TypedGlamor.smallCaps),
	/* :: */[TypedGlamor.select("@media (max-width: 450px)", /* :: */[TypedGlamor.marginRight(TypedGlamor.em(1)),
	/* [] */0]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.textDecoration(TypedGlamor.underline),
	/* [] */0]),
	/* :: */[TypedGlamor.select("&:not([href])", /* :: */[TypedGlamor.textDecoration(TypedGlamor.none),
	/* :: */[TypedGlamor.opacity(0.25),
	/* [] */0]]),
	/* [] */0]]]]]]]),
	/* [] */0]]]);
	
	var readme = TypedGlamor.css( /* Some */[CommonStyles.html], /* :: */[TypedGlamor.backgroundColor(Theme.Panel[/* Color */0][/* background */0]),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(2), TypedGlamor.em(4)),
	/* :: */[TypedGlamor.select("@media (max-width: 900px)", /* :: */[TypedGlamor.padding2(TypedGlamor.em(1), TypedGlamor.em(2)),
	/* [] */0]),
	/* [] */0]]]);
	
	exports.root = root;
	exports.header = header;
	exports.props = props;
	exports.title = title;
	exports.owner = owner;
	exports.name = name;
	exports.descLine = descLine;
	exports.description = description;
	exports.tags = tags;
	exports.tagsIcon = tagsIcon;
	exports.right = right;
	exports.updated = updated;
	exports.license = license;
	exports.nolicense = nolicense;
	exports.stars = stars;
	exports.starIcon = starIcon;
	exports.links = links;
	exports.readme = readme;
	/* root Not a pure module */

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	exports.__esModule = true;
	var Tag = __webpack_require__(472);
	var Icon = __webpack_require__(53);
	var Link = __webpack_require__(55);
	var Curry = __webpack_require__(6);
	var Flags = __webpack_require__(223);
	var Score = __webpack_require__(225);
	var React = __webpack_require__(1);
	var Config = __webpack_require__(76);
	var Helmet = __webpack_require__(77);
	var Vrroom = __webpack_require__(14);
	var TimeAgo = __webpack_require__(148);
	var Version = __webpack_require__(473);
	var Platforms = __webpack_require__(224);
	var ReasonReact = __webpack_require__(7);
	var TypedGlamor = __webpack_require__(4);
	var Js_primitive = __webpack_require__(124);
	var PackageStyles = __webpack_require__(543);
	
	__webpack_require__(646);
	
	var component = ReasonReact.statelessComponent("Package");
	
	function make(data, _) {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */function () {
	      document.querySelectorAll('.redex-codeblock.m-tabbed').forEach(function (el) {
	        el.querySelector('li.reason').addEventListener('click', function () {
	          el.querySelectorAll('.reason').forEach(function (_) {
	            return _.classList.add('s-selected');
	          });
	          el.querySelectorAll('.ml').forEach(function (_) {
	            return _.classList.remove('s-selected');
	          });
	        });
	
	        el.querySelector('li.ml').addEventListener('click', function () {
	          el.querySelectorAll('.reason').forEach(function (_) {
	            return _.classList.remove('s-selected');
	          });
	          el.querySelectorAll('.ml').forEach(function (_) {
	            return _.classList.add('s-selected');
	          });
	        });
	      });
	      return (/* () */0
	      );
	    },
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      var $$package = data.package;
	      var match = $$package.license;
	      var tmp = {};
	      var tmp$1 = Js_primitive.null_undefined_to_opt($$package.homepageUrl);
	      if (tmp$1) {
	        tmp.href = tmp$1[0];
	      }
	      var tmp$2 = {};
	      var tmp$3 = Js_primitive.null_undefined_to_opt($$package.repositoryUrl);
	      if (tmp$3) {
	        tmp$2.href = tmp$3[0];
	      }
	      var tmp$4 = {};
	      var tmp$5 = Js_primitive.null_undefined_to_opt($$package.npmUrl);
	      if (tmp$5) {
	        tmp$4.href = tmp$5[0];
	      }
	      var tmp$6 = {};
	      var tmp$7 = Js_primitive.null_undefined_to_opt($$package.issuesUrl);
	      if (tmp$7) {
	        tmp$6.href = tmp$7[0];
	      }
	      var tmp$8 = {};
	      var tmp$9 = Js_primitive.null_undefined_to_opt($$package.docsUrl);
	      if (tmp$9) {
	        tmp$8.href = tmp$9[0];
	      }
	      return React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.root)
	      }, ReasonReact.element( /* None */0, /* None */0, Helmet.make( /* Some */[Config.titleTemplate($$package.name)], /* None */0, /* None */0, /* None */0, /* array */[])), React.createElement("header", {
	        className: TypedGlamor.toString(PackageStyles.header)
	      }, React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.props)
	      }, ReasonReact.element( /* None */0, /* None */0, Curry._2(Vrroom.Control[/* IfSome */3][/* make */1], Js_primitive.null_undefined_to_opt($$package.stars), function (stars) {
	        return React.createElement("div", {
	          className: TypedGlamor.toString(PackageStyles.stars)
	        }, Vrroom.text(stars), ReasonReact.element( /* None */0, /* None */0, Icon.Star[/* make */0]( /* Some */[TypedGlamor.toString(PackageStyles.starIcon)], /* array */[])));
	      })), ReasonReact.element( /* None */0, /* None */0, Score.make($$package, /* array */[])), match == null ? React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.nolicense)
	      }, Vrroom.text("No license")) : React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.license)
	      }, Vrroom.text(match)), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.updated)
	      }, ReasonReact.element( /* None */0, /* None */0, TimeAgo.make($$package.updated, /* array */[])))), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.title)
	      }, ReasonReact.element( /* None */0, /* None */0, Link.make($$package.slug, /* Some */[TypedGlamor.toString(PackageStyles.name)], /* None */0, /* array */[Vrroom.text($$package.name)])), ReasonReact.element( /* None */0, /* None */0, Version.make($$package.version, $$package.type === "published", /* array */[])), ReasonReact.element( /* None */0, /* None */0, Platforms.make($$package.platforms, /* array */[]))), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.descLine)
	      }, ReasonReact.element( /* None */0, /* None */0, Flags.make($$package, /* Some */[true], /* array */[])), React.createElement("span", {
	        className: TypedGlamor.toString(PackageStyles.description)
	      }, Vrroom.text($$package.description))), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.tags)
	      }, ReasonReact.element( /* None */0, /* None */0, Icon.Tags[/* make */0]( /* Some */[PackageStyles.tagsIcon], /* array */[])), ReasonReact.element( /* None */0, /* None */0, Tag.Category[/* make */2]($$package.category, /* array */[])), ReasonReact.element( /* None */0, /* None */0, Curry._3(Vrroom.Control[/* Map */0][/* make */1], $$package.keywords, /* None */0, function (keyword) {
	        return ReasonReact.element( /* Some */[keyword], /* None */0, Tag.Keyword[/* make */1](keyword, /* array */[]));
	      }))), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.links)
	      }, React.createElement("a", tmp, Vrroom.text("homepage")), React.createElement("a", tmp$2, Vrroom.text("repository")), React.createElement("a", tmp$4, Vrroom.text("npm")), React.createElement("a", tmp$6, Vrroom.text("issues")), React.createElement("a", tmp$8, Vrroom.text("documentation")))), React.createElement("div", {
	        className: TypedGlamor.toString(PackageStyles.readme),
	        dangerouslySetInnerHTML: {
	          __html: $$package.readme
	        }
	      }));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function (jsProps) {
	  return make(jsProps.data, /* array */[]);
	});
	
	var query = exports.query = "** extracted graphql fragment **";
	
	var Styles = 0;
	
	exports.Styles = Styles;
	exports.component = component;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/*  Not a pure module */

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-package-js-747967dc16d9b590a9d6.js